module.exports = __webpack_public_path__ + "img/logo.48a65d9c.svg";